import { IPlanEnrollment, IPlanEnrollmentListQuery } from "./types";
import { planEnrollmentService } from "./service";

export const getPlanEnrollments = async (
  query?: IPlanEnrollmentListQuery
): Promise<IPlanEnrollment[]> => {
  const { data } = await planEnrollmentService.get(``, {
    params: query
  });

  return data;
};
